import React from 'react';
import './MainPage.css';
import NoticeWidget from './NoticeWidget';
import ScheduleWidget from './ScheduleWidget';
import CompanyScheduleWidget from './CompanyScheduleWidget';

const MainPage = () => {
  return (
    <div className="main-page">
      <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', padding: '36px clamp(16px, 3vw, 40px) 0' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 32, flexWrap: 'wrap', width: '100%' }}>
          {/* 일정 카드(ScheduleWidget 내 첫 카드)와 동일한 고정 폭으로 공지 열 정렬 */}
          <div style={{ flex: '0 1 340px', width: 340, minWidth: 280, maxWidth: '100%' }}>
            <NoticeWidget />
          </div>
          <div style={{ flex: '1 1 560px', minWidth: 0 }}>
            <ScheduleWidget />
          </div>
        </div>
        {/* 구분선: 메인 컨텐츠 영역에만 */}
        <div style={{ width: '100%', borderBottom: '1.5px solid #e0e0e0', margin: '36px 0 0 0' }} />
        {/* 회사주요일정: 본문 폭의 35%(좌측 정렬) */}
        <div style={{ marginTop: 0, width: '100%' }}>
          <div style={{ width: '35%', maxWidth: '100%', boxSizing: 'border-box' }}>
            <CompanyScheduleWidget />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainPage; 